<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">اختصاص یک استاد به یک درس/دوره</h1>
          <b-row class="my-2">
            <div
              class="d-flex align-items-center w-100 mt-1"
              style="gap: 1.5rem"
            >
              <b-form-radio
                v-model="isCourse"
                name="status"
                class="custom-control-primary"
                :value="true"
              >
                اختصاص استاد به دوره
              </b-form-radio>
              <b-form-radio
                v-model="isCourse"
                name="status"
                class="custom-control-primary"
                :value="false"
              >
                اختصاص استاد به درس
              </b-form-radio>
            </div>
          </b-row>
          <b-row class="p-2">
            <b-col cols="12" md="6">
              <MasterPicker
                ref="masterPicker"
                @getMaster="setMaster"
              ></MasterPicker>
            </b-col>
            <b-col cols="12" md="6">
              <course-picker
                ref="coursePicker"
                @getCourse="setCourse"
              ></course-picker>
            </b-col>
            <b-col cols="12" md="6" v-if="!isCourse">
              <lesson-picker
                ref="lessonPicker"
                @getLesson="setLessonId"
                :defaultCourseId="masterActiveCourseDetails.courseId"
              ></lesson-picker>
            </b-col>
            <div class="d-flex align-items-center justify-content-end w-100">
              <b-button type="button" variant="primary" @click="decideAction">
                {{ isCourse ? "اختصاص استاد به دوره" : "اختصاص استاد به درس" }}
              </b-button>
            </div>
          </b-row>
          <hr v-if="masterActiveCourses" />
          <b-row class="p-2" v-if="masterActiveCourses">
            <b-col cols="12">
              <h3>لیست دوره های فعال این استاد</h3>
            </b-col>
            <b-col
              cols="12"
              md="4"
              v-for="course in masterActiveCourses"
              :key="course.courseId"
            >
              <div
                class="w-100 shadow p-2 m-1 d-flex align-items-center justify-content-between"
              >
                <p>
                  {{ course.courseTitle }}
                </p>
                <b-button
                  variant="transparent"
                  class="cursor-pointer"
                  @click="setTempMasterActiveCourse(course)"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    class="text-danger"
                    size="20"
                  />
                </b-button>
              </div>
            </b-col>
          </b-row>
          <hr v-if="masterActiveLessons" />
          <b-row class="p-2" v-if="masterActiveLessons">
            <b-col cols="12">
              <h3>لیست درس های فعال این استاد</h3>
            </b-col>
            <b-col
              cols="12"
              md="4"
              v-for="lesson in masterActiveLessons"
              :key="lesson.lessonId"
            >
              <div
                class="w-100 shadow p-2 m-1 d-flex align-items-center justify-content-between"
              >
                <p>
                  {{ lesson.lessionTitle }}
                </p>
                <b-button
                  variant="transparent"
                  class="cursor-pointer"
                  @click="setTempMasterActiveLesson(lesson)"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    class="text-danger"
                    size="20"
                  />
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <!-- Delete Course Modal Start -->
    <b-modal
      title="حذف استاد از دوره"
      id="master-active-course-delete"
      centered
      ok-title="حذف"
      cancel-title="بستن"
      @ok="deleteMasterActiveCourse"
    >
      <p>آیا از حذف استاد از این دوره اطمینان دارید؟</p>
    </b-modal>
    <!-- Delete Course Modal End -->

    <!-- Delete Lesson Modal Start -->
    <b-modal
      title="حذف استاد از درس"
      id="master-active-lesson-delete"
      centered
      ok-title="حذف"
      cancel-title="بستن"
      @ok="deleteMasterActiveLesson"
    >
      <p>آیا از حذف استاد از این درس اطمینان دارید؟</p>
    </b-modal>
    <!-- Delete Lesson Modal End -->
  </b-overlay>
</template>
<script>
import {
  CreateMasterActiveCourse,
  GetAllMasterActiveCourse,
  DeleteAMasterActiveCourse,
} from "@/libs/Api/MasterActiveCourse";
import {
  CreateMasterActiveLesson,
  DeleteMasterActiveLesson,
  GetAllMasterActiveLesson,
} from "@/libs/Api/MasterActiveLesson";
import MasterPicker from "@/views/components/MasterActiveCourse/MasterPicker.vue";
import CoursePicker from "@/views/components/MasterActiveCourse/CoursePicker.vue";
import {
  BCard,
  BRow,
  BCol,
  BFormRadio,
  BButton,
  BOverlay,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import LessonPicker from "@/views/components/Lessons/LessonPicker.vue";

export default {
  data() {
    return {
      masterActiveCourseDetails: {
        isDeleted: false,
        masterActiveCourseId: 0,
        masterUserId: null,
        courseId: null,
        createDate: new Date(Date.now()),
      },
      masterActiveLessonDetails: {
        id: 0,
        lessonId: null,
        userId: null,
      },
      masterActiveLessonsFilters: {
        userFullname: null,
        userMobile: null,
        userNationalId: null,
        lessionTitle: null,
        masterUserId: null,
        pageNumber: 1,
        take: 10,
      },
      masterActiveCourses: null,
      masterActiveLessons: null,
      tempCourse: null,
      tempLesson: null,
      isLoading: false,
      isCourse: false,
    };
  },
  methods: {
    setLessonId(lessonId) {
      this.masterActiveLessonDetails.lessonId = lessonId;
    },
    handleMasterActiveLessonsFilters() {
      let payload = {
        pageNumber: this.masterActiveLessonsFilters.pageNumber,
        take: this.masterActiveLessonsFilters.take,
      };
      if (this.masterActiveLessonsFilters.userFullname) {
        payload["userFullname"] = this.masterActiveLessonsFilters.userFullname;
      }
      if (this.masterActiveLessonsFilters.userMobile) {
        payload["userMobile"] = this.masterActiveLessonsFilters.userMobile;
      }
      if (this.masterActiveLessonsFilters.userNationalId) {
        payload["userNationalId"] =
          this.masterActiveLessonsFilters.userNationalId;
      }
      if (this.masterActiveLessonsFilters.lessionTitle) {
        payload["lessionTitle"] = this.masterActiveLessonsFilters.lessionTitle;
      }
      if (this.masterActiveLessonsFilters.masterUserId) {
        payload["masterUserId"] = this.masterActiveLessonsFilters.masterUserId;
      }
      return payload;
    },
    setTempMasterActiveCourse(course) {
      this.tempCourse = JSON.parse(JSON.stringify(course));
      this.$bvModal.show("master-active-course-delete");
    },
    setTempMasterActiveLesson(lesson) {
      this.tempLesson = JSON.parse(JSON.stringify(lesson));
      this.$bvModal.show("master-active-lesson-delete");
    },
    async deleteMasterActiveLesson() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteMasterActiveLesson = new DeleteMasterActiveLesson(_this);
        deleteMasterActiveLesson.setRequestParam({ id: _this.tempLesson.id });
        await deleteMasterActiveLesson.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "استاد با موفقیت از درس حذف شد",
                icon: "CheckIcon",
                variant: "success",
              },
            });
            _this.getAllMasterActiveLessons();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "Trash2Icon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async deleteMasterActiveCourse() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteAMasterActiveCourse = new DeleteAMasterActiveCourse(_this);
        deleteAMasterActiveCourse.setRequestParam({
          id: _this.tempCourse.masterActiveCourseId,
        });
        await deleteAMasterActiveCourse.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "استاد با موفقیت از دوره حذف شد",
                icon: "CheckIcon",
                variant: "success",
              },
            });
            _this.getAllMasterActiveCourses();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllMasterActiveCourses() {
      try {
        this.isLoading = true;
        let qParams = {
          count: 0,
          pageNumber: 0,
        };
        if (this.masterActiveCourseDetails.masterUserId) {
          qParams["masterUserId"] = this.masterActiveCourseDetails.masterUserId;
        }
        let _this = this;
        let getAllMasterActiveCourse = new GetAllMasterActiveCourse(_this);
        getAllMasterActiveCourse.setRequestParam(qParams);
        await getAllMasterActiveCourse.fetch((response) => {
          if (response.isSuccess) {
            _this.masterActiveCourses = response.data.masterActiveCourses;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    decideAction() {
      if (this.isCourse) {
        this.createAMasterActiveCourse();
      } else {
        this.createAMasterActiveLesson();
      }
    },
    async getAllMasterActiveLessons() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllMasterActiveLesson = new GetAllMasterActiveLesson(_this);
        getAllMasterActiveLesson.setRequestParamDataObj(
          _this.handleMasterActiveLessonsFilters()
        );
        await getAllMasterActiveLesson.fetch((res) => {
          _this.masterActiveLessons = res.data;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    clearSelectedMaster() {
      this.$refs.masterPicker?.clearSelectedMaster &&
        this.$refs.masterPicker?.clearSelectedMaster();
    },
    clearSelectedLesson() {
      this.$refs.lessonPicker?.clearSelectedLesson &&
        this.$refs.lessonPicker?.clearSelectedLesson();
    },
    clearSelectedCourse() {
      this.$refs.coursePicker?.clearSelectedCourse &&
        this.$refs.coursePicker?.clearSelectedCourse();
    },
    async createAMasterActiveLesson() {
      try {
        this.isLoading = true;
        let _this = this;
        let createMasterActiveLesson = new CreateMasterActiveLesson(_this);
        createMasterActiveLesson.setRequestParamDataObj(
          _this.masterActiveLessonDetails
        );
        await createMasterActiveLesson.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "استاد با موفقیت به درس اختصاص داده شد",
                icon: "CheckIcon",
                variant: "success",
              },
            });
            // _this.clearSelectedMaster();
            _this.clearSelectedLesson();
            _this.getAllMasterActiveLessons();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ثبت نشد!",
                icon: "Trash2Icon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async createAMasterActiveCourse() {
      try {
        this.isLoading = true;
        let _this = this;
        let createMasterActiveCourse = new CreateMasterActiveCourse(_this);
        createMasterActiveCourse.setRequestParamDataObj(
          _this.masterActiveCourseDetails
        );
        await createMasterActiveCourse.fetch(function (response) {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "استاد با موفقیت به دوره اختصاص داده شد",
                icon: "CheckIcon",
                variant: "success",
              },
            });
            // _this.clearSelectedMaster();
            _this.clearSelectedCourse();
            _this.getAllMasterActiveCourses();
          }
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "تکراری",
            text: "این دوره قبلا به این استاد اختصاص داده شده است.",
            icon: "CheckIcon",
            variant: "danger",
          },
        });
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setMaster(master) {
      this.masterActiveCourseDetails.masterUserId = master
        ? master.userId
        : null;
      this.masterActiveLessonsFilters.masterUserId = master
        ? master.userId
        : null;
      this.masterActiveLessonDetails.userId = master ? master.userId : null;
      this.getAllMasterActiveCourses();
      this.getAllMasterActiveLessons();
    },
    setCourse(courseId) {
      this.masterActiveCourseDetails.courseId = courseId;
    },
  },
  components: {
    CoursePicker,
    MasterPicker,
    BCard,
    BRow,
    BCol,
    BFormRadio,
    BButton,
    BOverlay,
    LessonPicker,
  },
};
</script>
